import { render } from "./ReportNewPatients.vue?vue&type=template&id=7f17601d&scoped=true"
import script from "./ReportNewPatients.vue?vue&type=script&lang=js"
export * from "./ReportNewPatients.vue?vue&type=script&lang=js"

import "./ReportNewPatients.vue?vue&type=style&index=0&id=7f17601d&lang=css"
import "./ReportNewPatients.vue?vue&type=style&index=1&id=7f17601d&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f17601d"]])

export default __exports__